$(document).ready(function () {
  const observer = new MutationObserver(mutation => {
    if (mutation[0] && mutation[0].addedNodes[0] && mutation[0].addedNodes[0].className == 'EmptyState') {
      $('#no-results-container').addClass('is-visible');
    }
  });

  const productsCollection = document.querySelector('.CollectionInner__Products');

  observer.observe(productsCollection, {
    childList: true,
  });

  if (/redirect=configurator/.test(window.location.href)) {
    $('#no-results-configurator-container').addClass('is-visible');
  } else {
    $('#no-results-container').addClass('is-visible');
  }

  $('#no-results-configurator-button').click(function () {
    parent.history.back();
    return false;
  });
});
